import { useEffect, useState } from "react";
import api from "@/lib/api";
import { KRAKEN_FULL_LOGO } from "@/components/PublicLayout";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/media").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="gallery-page" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h1 className="font-display text-6xl sm:text-7xl uppercase font-bold tracking-tight">Media</h1>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {items.length === 0 ? (
            <div className="sm:col-span-2 lg:col-span-3 flex justify-center">
              <div className="kr-card rounded-xl overflow-hidden max-w-md w-full" data-testid="gallery-coming-soon">
                <div className="aspect-square bg-gradient-to-b from-[#14213D] to-[#050A15] flex items-center justify-center p-10">
                  <img src={KRAKEN_FULL_LOGO} alt="Coastal Kraken" className="w-full h-full object-contain drop-shadow-[0_0_40px_rgba(0,229,255,0.4)]" />
                </div>
                <div className="p-5 text-center">
                  <div className="font-display text-2xl uppercase">More Content Coming Soon</div>
                </div>
              </div>
            </div>
          ) : items.map((m) => (
            <div key={m.id} className="kr-card rounded-xl overflow-hidden" data-testid={`media-${m.id}`}>
              <div className="aspect-[4/3] overflow-hidden">
                {m.url && <img src={m.url} alt={m.title} className="w-full h-full object-cover hover:scale-105 transition" />}
              </div>
              <div className="p-4">
                <div className="font-display text-lg uppercase">{m.title}</div>
                {m.caption && <div className="text-slate-400 text-sm mt-1">{m.caption}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
